module.exports = {
    funnelUnder: {
        texture: '/img/partials/funnel/funnel-under.png',
        scale: {
            x: '85%',
        },
        position: {
            x: '7%',
            y: '40%'
        }
    },

    funnelOver: {
        texture: '/img/partials/funnel/funnel-over.png',
        scale: {
            x: '93%',
        },
        position: {
            x: '7%',
            y: '41%'
        }
    },

    funnelLid: {
        texture: '/img/partials/funnel/funnel-lid.png',
        scale: {
            x: '93%',
        },
        position: {
            x: '7%',
            y: '41%'
        }
    },

    funnelPipe: {
        texture: '/img/partials/funnel/funnel-pipe.png',
        scale: {
            x: '93%',
        },
        position: {
            x: '7%',
            y: '41%'
        }
    },

    funnelPipeBg: {
        texture: '/img/partials/funnel/funnel-pipe-bg.jpg',
        scale: {
            x: '100%'
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/funnelPipe.js